export class SoProductCompleteNotShipped {
    poNumbr: string;
    orderCases: string;
    fgCases: string;
    completedPercentage: string;
}